module.exports = __webpack_public_path__ + "static/media/logo_wirebit.aa36f631.svg";